[data-html5-video] {
  position: absolute;
  height: 100%;
  width: 100%;
  display: block;
}
